<template>
  <div class="app-container withdraw">
    <div class="typeHeader">
      <div class="header" style="display:flex;justify-content:flex-end;align-items:center;width:100%;margin-bottom: 10px;">
      <el-input
          v-model="listQuery.batch"
          placeholder="批次号"
          :clearable="true"
          style="width: 200px;margin: 0px 10px;margin-left: 20px;"
        ></el-input>

        <el-input
          v-model="listQuery.card_code"
          placeholder="劵码"
          :clearable="true"
          style="width: 200px;margin: 0px 10px;margin-left: 20px;"
        ></el-input>

        <el-input
          v-model="listQuery.usage_user_id"
          placeholder="核销用户编码"
          :clearable="true"
          style="width: 200px;margin: 0px 10px;margin-left: 20px;"
        ></el-input>

        <el-input
          v-model="listQuery.parent_invitation"
          placeholder="上级编码"
          :clearable="true"
          style="width: 200px;margin: 0px 10px;margin-left: 20px;"
        ></el-input>

        <el-select v-model="listQuery.state" placeholder="状态" type="primary"  clearable>
          <el-option label="待使用" :value="0" />
          <el-option label="已核销" :value="1" />
        </el-select>

        <el-button
          type="primary"
          style="margin-left: 15px;"
          @click="search"
          >搜索</el-button>
        <span >
          <download-excel
              :fields="json_fields"
              :fetch="handleExport"
              type="xls"
              name="会员卡.xls"
              worksheet="会员卡"
          >
            <el-button type="success" :loading="exportLoading" class="filter-item" style="width:180px">
              导出Excel
            </el-button>
          </download-excel>
        </span> 
    </div>

    <div class="header" style="display:flex;justify-content:flex-end;align-items:center;width:100%;">
      <el-date-picker

        v-model="start_date"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
        placeholder="请选择开始时间"
      ></el-date-picker>
      <el-date-picker
        v-model="end_date"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
        placeholder="请选择结束时间"
        style="margin-left: 20px;"
      ></el-date-picker>
      <el-button
        type="primary"
        style="margin-left: 15px;"
        @click="parent"
        >设置上级</el-button
      >
      <el-button
        type="primary"
        style="margin-left: 15px;"
        @click="setUp"
        >批量设置</el-button
      >
      <el-button
        type="primary"
        style="margin-left: 15px;"
        @click="delAll"
        >批量删除</el-button
      >
    </div>
    </div>

    <el-dialog :title="title" v-if="showDialog" :visible.sync="showDialog" :append-to-body="true" :close-on-click-modal=false>
      <el-form ref="form" :model="form" label-width="120px">
        
        <el-form-item label="批次号">
          <el-input
            v-model="form.batch"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入批次号"
          ></el-input>
        </el-form-item>

        <el-form-item label="会员卡数量">
          <el-input
            v-model.number="form.num"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入数量"
          ></el-input>
        </el-form-item>

        <el-form-item label="会员有效时长(月)">
          <el-input
            v-model.number="form.months"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入数量"
          ></el-input>
        </el-form-item>

        <el-form-item label="解锁课程"  >
          <el-switch
            v-model="is_course"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>

        </el-form-item>

        <el-form-item style="text-align: right">
          <el-button size="small" @click="handleCancel" :loading="btnLoading">返回</el-button>
          <el-button
            size="small"
            @click="handleSubmit"
            type="primary"
            :loading="btnLoading"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="title" v-if="delDialog" :visible.sync="delDialog" :append-to-body="true" :close-on-click-modal=false>
      <el-form ref="form" :model="form" label-width="120px">
        
        <el-form-item label="批次号">
          <el-input
            v-model="form.batch"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入批次号"
            @change = "getBatch"
          ></el-input>
        </el-form-item>

        <el-form-item label="会员卡区间">
          <dev>
            <p>{{this.batch_min}} 到 {{this.batch_max}} </p>
          <el-input
            v-model.number="form.min"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入卡号"
          ></el-input>
          到
          <el-input
            v-model.number="form.max"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入卡号"
            
          ></el-input>
          共 {{form.max - form.min +1}}
          </dev>
          </el-form-item>

        <el-form-item style="text-align: right">
          <el-button size="small" @click="handleDelAll" :loading="delLoading">返回</el-button>
          <el-button
            size="small"
            @click="handleSubmitDelCard"
            type="primary"
            :loading="delLoading"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="title" v-if="setDialog" :visible.sync="setDialog" :append-to-body="true" :close-on-click-modal=false>
      <el-form ref="form" :model="form" label-width="120px">
        
        <el-form-item label="批次号">
          <el-input
            v-model="form.batch"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入批次号"
            @change = "getBatch"
          ></el-input>
        </el-form-item>

        <el-form-item label="会员卡区间">
          <dev>
            <p>{{this.batch_min}} 到 {{this.batch_max}} </p>
          <el-input
            v-model.number="form.min"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入卡号"
          ></el-input>
          到
          <el-input
            v-model.number="form.max"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入卡号"
            
          ></el-input>
          共 {{form.max - form.min +1}}
          </dev>
          </el-form-item>

          <el-form-item label="会员类型" >
          <el-select v-model="form.card_type" style="width: 200px">
            <el-option label="普通会员" :value="1" />
            <el-option label="金牌代理" :value="2" />
            <el-option label="银牌代理" :value="3" />
          </el-select>
        </el-form-item>

        <el-form-item label="会员有效时长(月)" v-if="form.card_type===1">
          <el-input
            v-model.number="form.months"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入数量"
          ></el-input>
        </el-form-item>

        <el-form-item label="赠送能量">
          <el-input
            v-model.number="form.energy_num"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入数量"
          ></el-input>
        </el-form-item>

        <el-form-item label="解锁课程"  >
          <el-switch
            v-model="is_course"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>

        </el-form-item>

        <el-form-item style="text-align: right">
          <el-button size="small" @click="handleSetUp" :loading="setLoading">返回</el-button>
          <el-button
            size="small"
            @click="handleSubmitSetCard"
            type="primary"
            :loading="setLoading"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="title" v-if="parentDialog" :visible.sync="parentDialog" :append-to-body="true" :close-on-click-modal=false>
      <el-form ref="form" :model="form" label-width="120px">
        
        <el-form-item label="批次号">
          <el-input
            v-model="form.batch"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入批次号"
            @change = "getBatch"
          ></el-input>
          
         
        </el-form-item>

        <el-form-item label="会员卡区间">
          <dev>
            <p>{{this.batch_min}} 到 {{this.batch_max}} </p>
          <el-input
            v-model.number="form.min"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入卡号"
          ></el-input>
          到
          <el-input
            v-model.number="form.max"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入卡号"
            
          ></el-input>
          共 {{form.max - form.min +1}}
          </dev>
          </el-form-item>

        <el-form-item label="上级编码">
          <el-input
            v-model="form.parent_invitation"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入编码"
            @change = "getParent"
          ></el-input>
        </el-form-item>  

        <el-form-item label="头像">
          <dev>
             <el-avatar :src= "this.parent_user_head" ></el-avatar>
             <p>{{ this.parent_user_name}}</p>
          </dev>
        </el-form-item>  

        <el-form-item style="text-align: right">
          <el-button size="small" @click="handleParen" :loading="parentLoading">返回</el-button>
          <el-button
            size="small"
            @click="handleSubmitparent"
            type="primary"
            :loading="parentLoading"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
   
    <el-table
      :loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="margin-top: 15px;"
    >
    <el-table-column label="批次号" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.batch }}</template>
      </el-table-column>
      
       <el-table-column label="会员卡号" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.card_nos
        }}</template>
      </el-table-column>
      <el-table-column label="会员劵码" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.card_code
        }}</template>
      </el-table-column>
     
      <el-table-column label="会员时间" align="center" min-width="110">
        <template slot-scope="scope" >
          <el-tag type="success" v-if="scope.row.card_type === 2">永久</el-tag>
          <template v-else >{{ scope.row.months }}个月</template>
          </template>
      </el-table-column>

    
      <el-table-column label="是否解锁课程" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.is_course == 1">解锁</el-tag>
          <el-tag type="danger" v-if="scope.row.is_course == 0">锁定</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="会员卡类型" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.card_type == 1">普通会员</el-tag>
          <el-tag type="warning" v-if="scope.row.card_type == 2">金牌会员</el-tag>
          <el-tag type="primary" v-if="scope.row.card_type == 3">银牌会员</el-tag>
        </template>
      </el-table-column>
      
      <el-table-column label="能量" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.energy_num }}</template>
      </el-table-column>

      <el-table-column label="状态" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.state == 0">待使用</el-tag>
          <el-tag type="info" v-if="scope.row.state == 1">已使用</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="上级编码" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.parent_invitation?scope.row.parent_invitation:'-' }}</template>
      </el-table-column>

      <el-table-column label="上级名称" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.parent_info?scope.row.parent_info.nickname:'-' }}</template>
      </el-table-column>

      <el-table-column label="核销人编码" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.usage_user?scope.row.usage_user.invitation_code:'-'}}</template>
      </el-table-column>

      <el-table-column label="核销人名称" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.usage_user?scope.row.usage_user.nickname:'-'}}</template>
      </el-table-column>

      <el-table-column label="核销时间" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.usage_at?scope.row.usage_at:'-'
        }}</template>
      </el-table-column>

      <el-table-column label="创建时间" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.created_at
        }}</template>
      </el-table-column>
     
    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import downloadExcel from "vue-json-excel";

export default {
  components: { downloadExcel },
  data() {
    return {
      listLoading: false,
      total: 1,
      listQuery: {
        page: 1,
        limit: 10,
        start_date: "",
        end_date: "",
        name_phone: "",
      },
      reason : '',
      from:{
      
      },
      form:{
        batch:'',
        max:'',
        min:'',
        parent_invitation:'',
      },
      parent_user_head:'',
      parent_user_name:'',
      batch_max:0,
      batch_min:0,
      start_date: "",
      end_date: "",
      dialogVisible: false,
      is_course: true,
      list: [],
      rewardMoney: 0,
      cashoutMoney: 0,
      cashoutUnAdoptMoney: 0,
      cashoutAdoptMoney: 0,
      imgDialog : false,
      rejectVisible : false,
      url:'',
      showDialog : false,
      btnLoading : false,
      delDialog : false,
      delLoading : false,
      parentDialog : false,
      parentLoading : false,
      setDialog : false,
      setLoading : false,
      is_course: true,

      json_fields: {
        // 批次号: {
        //   field: "batch",
        //   //自定义回调函数
        //   callback: (value) => {
        //     return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
        //   },
        // },
        会员卡号: {
          fields: "batch",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value.batch + value.card_nos + "</p>";
          },
        },
        兑换码: {
          field: "card_code",
          //自定义回调函数
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        // 会员时间: {
        //   field: "months",
        //   //自定义回调函数
        //   callback: (value) => {
        //     return "<p style=\"mso-number-format:'\\@';\">" + value + '个月' + "</p>";
        //   },
        // },
        // 是否解锁课程: {
        //   field: "is_course",
        //   //自定义回调函数
        //   callback: (value) => {
        //     var a = value == 1 ? '解锁':'锁定';
        //     return "<p style=\"mso-number-format:'\\@';\">" + a + "</p>";
        //   },
        // },
        // 状态: {
        //   field: "state",
        //   //自定义回调函数
        //   callback: (value) => {
        //     var a =  value == 1 ?'已核销':'待使用';
        //     return "<p style=\"mso-number-format:'\\@';\">" + a + "</p>";
        //   },
        // },
        // 核销时间: {
        //   field: "usage_at",
        //   //自定义回调函数
        //   callback: (value) => {
        //     return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
        //   },
        // },

        // 创建时间: {
        //   field: "created_at",
        //   //自定义回调函数
        //   callback: (value) => {
        //     return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
        //   },
        // }, 
        }, 
        exportLoading:false
    };
  },
  mounted() {
    this.getList();
    // console.log(this.$store.state.user.username)
  },
  methods: {
    getList() {
      console.log(123213);
      this.listLoading = true;
      this.listQuery.start_date = this.start_date
        ? this.start_date + " 00:00:00"
        : "";
      this.listQuery.end_date = this.end_date
        ? this.end_date + " 23:59:59"
        : "";
      request({
        url: "/api/backend/memberCard/index",
        method: "get",
        params: this.listQuery
      })
        .then(result => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(err => {
          console.log(err);
        });
    },
    onAdd() {
      this.title = "新增类型";
      this.resetData();
      this.showDialog = true;
    },
    resetData() {
      this.form = {
        months:'',
        batch:'',
        is_course: true,
        num:''
      };
      this.is_course = true;
    },
    handleCancel() {
      this.btnLoading = false;
      this.showDialog = false;
    },
    handleDelAll() {
      this.delDialog = false;
      this.delLoading = false;
    },
    handleParen() {
      this.parentDialog = false;
      this.parentLoading = false;
    },
    handleSetUp() {
      this.setDialog = false;
      this.setLoading = false;
    },
    getParent() {
      if(this.form.parent_invitation ==='')
      {
          return;
      }
      request({
        url: "/api/backend/user/index",
        method: "get",
        params: {invitation_code:this.form.parent_invitation}
      })
        .then(result => {
            if (typeof result.data.data[0] === 'undefined') {
              this.$notify.error("用户不存在");
            } else {
                this.parent_user_head = result.data.data[0].avatar;
                this.parent_user_name = result.data.data[0].nickname;
            }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(err => {
          console.log(err);
        });
    },
    getBatch() {
      if(this.form.batch ==='')
      {
          return;
      }
      request({
        url: "/api/backend/memberCard/getBatch",
        method: "get",
        params: {batch:this.form.batch}
      })
        .then(result => {
            this.batch_max = result.data.max;
            this.batch_min = result.data.min;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(err => {
          console.log(err);
        });
    },
    handleSubmitparent() {
      this.parentLoading = true;
      this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {          
          request({
            url: "/api/backend/memberCard/createInvitation",
            method: "post",
            data: this.form,
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
              this.parentDialog = false;
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
              this.parentLoading = false;
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
          this.parentLoading = false;
        });
    },
    handleSubmitDelCard() {
      this.delLoading = true;
      this.$confirm("此操作将删除，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {
          request({
            url: "/api/backend/memberCard/delCard",
            method: "post",
            data: this.form,
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
              this.delDialog = false;
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
              this.delLoading = false;
              // this.delDialog = false;
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
          this.delLoading = false;
        });
    },
    handleSubmitSetCard() {
      this.setLoading = true;
      this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {
          if (this.is_course) {
            this.form.is_course = 1;
          }else
          {
            this.form.is_course = 0;
          }
          request({
            url: "/api/backend/memberCard/setUpCard",
            method: "post",
            data: this.form,
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
              this.setDialog = false;
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
              this.setLoading = false;
              // this.delDialog = false;
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
          this.setLoading = false;
        });
    },
    handleExport() {
      this.exportLoading = true;
      var query = JSON.parse(JSON.stringify(this.listQuery));
      query.limit = 99999999999999;
      query.page = 1;
      return request({
        url: "/api/backend/memberCard/index",
        method: "get",
        params: query,
      })
        .then((result) => {
          var json_data = result.data.data;
          this.header = "会员卡记录";
          return json_data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.listLoading = false;
          this.exportLoading = false;
        });
    },
    handleSubmit() {
      this.btnLoading = true;
      this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {
          if (this.is_course) {
            this.form.is_course = 1;
          }else
          {
            this.form.is_course = 0;
          }
          request({
            url: "/api/backend/memberCard/createCard",
            method: "post",
            data: this.form,
            timeout: 0,
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
              this.showDialog = false;
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
              this.btnLoading = false;
              // this.showDialog = false;
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
          this.btnLoading = false;
        });
    },
    search() {
      this.listQuery.page = 1
      this.getList();
    },
    parent() {
      this.title = "设置上级";
      this.form={};
      this.parent_user_head = '';
      this.parent_user_name = '';
      this.batch_max = '';
      this.batch_min = '';
      this.parentDialog = true;
    },
    delAll() {
      this.title = "批量删除";
      this.form={};
      this.parent_user_head = '';
      this.parent_user_name = '';
      this.batch_max = '';
      this.batch_min = '';
      this.delDialog = true;
    },
    setUp() {
      this.title = "批量设置";
      this.form={};
      this.parent_user_head = '';
      this.parent_user_name = '';
      this.batch_max = '';
      this.batch_min = '';
      this.setDialog = true;
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCode(row) {
      this.imgDialog = true;
      this.url = row.pay_code;
    },
    handleCloseCode(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            this.imgDialog = false;
            this.rejectVisible = false;
            this.url = '';
            this.from = {};
          })
          .catch(_ => {});
      },
    cancel() {
      this.dialogVisible = false;
      },
  }
};
</script>

<style>
.fenxiao {
  display: inline-block;
  padding: 20px 30px;
  margin-right: 20px;
  background-color: rgba(255, 0, 0, 0.438);
  color: #ffffff;
  margin-top: 10px;
  border-radius: 30px;
}
</style>